import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function FanVoteVerifyPage() {
  const [state, setState] = useState("working");
  useEffect(() => {
    const token = new URLSearchParams(window.location.hash.slice(1)).get("token");
    window.history.replaceState(null, "", "/fan-vote/verify");
    if (!token) { setState("invalid"); return; }
    api.post("/fan-vote/verify-email/confirm", { token }).then(() => setState("ok"))
      .catch((e) => setState(e?.response?.status === 401 ? "signin" : "invalid"));
  }, []);
  const msg = { working: "Verifying…", ok: "Your email is verified. You can vote now!", invalid: "This verification link is invalid or expired. Request a new one from the voting page.", signin: "Sign in with the same account first, then open the link again." }[state];
  return (
    <div className="min-h-screen bg-[#08080c] flex items-center justify-center p-6" data-testid="fanvote-verify-page">
      <div className="text-center space-y-3">
        <p className="text-white text-lg font-bold" data-testid="fanvote-verify-status">{msg}</p>
        <Link to={state === "signin" ? "/login" : "/fan-vote"} className="text-purple-300 underline" data-testid="fanvote-verify-continue">{state === "signin" ? "Sign in" : "Go to Fan Vote"}</Link>
      </div>
    </div>
  );
}
